
import { computed } from 'vue'
import { useTipsModel } from '@entities/tips'
import { useOrderModel } from '@entities/order'
import { useRestaurantModel } from '@entities/restaurant'
import { useThemeModel } from '@entities/theme'

export default {
  name: 'PrecheckMainScreen',
  props: {
    emptyOrder: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['togglePrecheck'],

  setup () {
    const orderModel = useOrderModel()
    const tipsModel = useTipsModel()
    const restaurantModel = useRestaurantModel()
    const themeModel = useThemeModel()

    const placeholderImage = computed(() => {
      return themeModel.theme.toLowerCase() === 'novikov'
        ? require('@/assets/img/empty-waiter-red.svg')
        : require('@/assets/img/empty-waiter.svg')
    })

    return {
      orderModel,
      tipsModel,
      restaurantModel,
      themeModel,
      placeholderImage
    }
  },

  computed: {

    // Есть офик
    hasWaiter () {
      if (this.orderModel.orderData && this.orderModel.orderData.waiter && this.orderModel.orderData.waiter.name && this.orderModel.orderData.waiter.card_verification) {
        return true
      }
      return false
    },

    // Есть семья
    hasFamily () {
      return !Array.isArray(this.orderModel.orderData?.team)
    },

    waiterName () {
      if (this.hasWaiter) {
        return this.orderModel.orderData.waiter.display_name ? this.orderModel.orderData.waiter.display_name : this.orderModel.orderData.waiter.name
      }
      if (this.hasFamily) {
        return 'Чаевые команде'
      }
      return 'Неизвестный официант'
    },

    orderText () {
      if (this.hasFamily || this.hasWaiter) {
        return 'и чаевые'
      }
      return ''
    },

    showTipsButton () {
      if ((this.orderModel.orderData && this.orderModel.orderData.waiter && this.orderModel.orderData.waiter.card_verification) || !Array.isArray(this.orderModel.orderData?.team)) {
        return true
      }
      return false
    }
  },
  methods: {
    redirectToTips () {
      window.location.href = this.tipsModel.tipsUrl
    }
  }
}
